import { ISettingsState } from "@domain/model/SettingsState";

export interface ISettingsService {
  persistedState?: ISettingsState;
  saveSettigsState(newState: ISettingsState): void;
  clearSettingsState(): void;
}

export const SettingsService = Symbol.for("SettingsService");
